import React from 'react';

const ActionButtonsManagerView = (props) => {
    const {children} = props;

    return (
        <div className="action-buttons-manager" style={{position: 'relative', bottom: '0', right: '0', width: '100%'}}>
            <div className="action-buttons-manager__bar" style={{textAlign: 'right', marginTop: '5px'}}>
                <div className="action-buttons-manager__row">
                    <div className="action-buttons-manager__buttons">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActionButtonsManagerView;
